import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { DireccionGeograficaIDE } from './direcciones-geografica-ide.model';

@Injectable({
  providedIn: 'root'
})
export class DireccionesGeograficaIDEService {
  url: string;

  constructor(private http: HttpClient) {}

  getDireccionesGeograficaIDE(q: string): Observable<DireccionGeograficaIDE[]> {
    return this.http.get<DireccionGeograficaIDE[]>(
      `https://direcciones.ide.uy/api/v1/geocode/candidates?limit=10&soloLocalidad=false&q=${q}`
    );
  }

  getDireccionesGeograficaExactaIDE(d: DireccionGeograficaIDE): Observable<DireccionGeograficaIDE[]> {
    return this.http.get<DireccionGeograficaIDE[]>(
      `https://direcciones.ide.uy/api/v1/geocode/find?type=${d.type}&departamento=${d.departamento}&localidad=${d.localidad}&idcalle=${d.idCalle}&portal=${d.portalNumber}`
    );
  }
}
